/**
 * Shared context-field resolvers, keyed by field name and read off a flow
 * component instance (state/props). Field names are shared across
 * searchFlowVersionB / regFlowVersionB / kftRegFlowVersionB / vafFlowVersionB —
 * each flow's step registry only references the subset it actually collects.
 */
export const CONTEXT_FIELD_RESOLVERS = {
  fillingMethod: (flowInstance) => flowInstance.state?.fillingMethodSelection || "",
  routingSelection: (flowInstance) => flowInstance.state?.routingSelection || "",
  moreBranchSelection: (flowInstance) => flowInstance.state?.moreBranchSelection || "",
  companyTypeFlowSelection: (flowInstance) =>
    flowInstance.state?.companyTypeFlowSelection || "",
  regCompanyTypeSelection: (flowInstance) =>
    flowInstance.state?.regCompanyTypeSelection || "",
  regEntrySource: (flowInstance) => flowInstance.state?.regEntrySource || "",
  kftInterstitialSelection: (flowInstance) =>
    flowInstance.state?.kftInterstitialSelection || "",
  kftCegjelzoInterstitialSelection: (flowInstance) =>
    flowInstance.state?.kftCegjelzoInterstitialSelection || "",
  multiCompanyInterstitialSelection: (flowInstance) =>
    flowInstance.state?.multiCompanyInterstitialSelection || "",
  cegjelzoSelected: (flowInstance) =>
    Boolean(flowInstance.props?.company_store?.cegjelzoData),
  industry: (flowInstance) => flowInstance.props?.company_store?.industry || "",
  companytype: (flowInstance) => flowInstance.props?.company_store?.companytype || "",
};
